import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'

const viewerManagerComponentApiFactory = (): IViewerManagerImplementor<'component'> => {
	return {
		component: {
			isComponentRenderedOnSite: (compId: string) => !!document.getElementById(compId),
		},
	}
}
export const ViewerManagerComponentApi = withDependencies([], viewerManagerComponentApiFactory)
